import axios from "axios";
import { getAdminToken } from "./adminAuth";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";

export const api = axios.create({
  baseURL: API_BASE_URL,
});

export async function fetchBlogPosts() {
  const response = await api.get("/blogs");
  return response.data;
}

export async function fetchBlogPost(slug) {
  const response = await api.get(`/blogs/${slug}`);
  return response.data;
}

export async function loginAdmin(payload) {
  const response = await api.post("/auth/login", payload);
  return response.data;
}

function getAdminAuthHeaders() {
  const token = getAdminToken();
  return {
    Authorization: `Bearer ${token}`,
  };
}

export async function createBlogPost(payload) {
  const response = await api.post("/blogs", payload, {
    headers: getAdminAuthHeaders(),
  });
  return response.data;
}

export async function fetchAdminBlogPosts() {
  const response = await api.get("/admin/blogs", {
    headers: getAdminAuthHeaders(),
  });
  return response.data;
}

export async function updateAdminBlogPost(postId, payload) {
  const response = await api.patch(`/admin/blogs/${postId}`, payload, {
    headers: getAdminAuthHeaders(),
  });
  return response.data;
}

export async function deleteAdminBlogPost(postId) {
  const response = await api.delete(`/admin/blogs/${postId}`, {
    headers: getAdminAuthHeaders(),
  });
  return response.data;
}

export async function submitDataDeletionRequest(payload) {
  const response = await api.post("/data-deletion-request", payload);
  return response.data;
}
